export default __webpack_public_path__ + "static/media/ColonialPenn.eb2d51a2.svg";